import React, { useState } from 'react';
import { supabase } from '../../../utils/supabaseClient';
import { Link } from 'react-router-dom';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setSuccessMsg('');
    setErrorMsg('');

    const cleanedEmail = email.trim().toLowerCase();

    const { error } = await supabase.auth.resetPasswordForEmail(cleanedEmail, {
      redirectTo: 'https://cici-nine.vercel.app/update-password',
    });

    if (error) {
      setErrorMsg(error.message);
    } else {
      setSubmitted(true);
      setSuccessMsg('Password reset email sent. Please check your inbox.');
    }
  };

  return (
    <section className="auth-page contain contain-smaller align-middle">
      <h1>Forgot password</h1>

      {successMsg && <p className="success-message">{successMsg}</p>}
      {errorMsg && <p className="error-message">{errorMsg}</p>}

      {!submitted && (
        <>
          <form onSubmit={handleForgotPassword}>
            <label htmlFor="email">Enter your email address:</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <div className="text-center">
              <button type="submit" className="btn mt-0">Continue</button>
            </div>
          </form>

          <div>
            <p>
              Go back to <Link to="/" className="link-text">Log in</Link>
            </p>
          </div>
        </>
      )}

      <div className="legal-links">
        <p className="text-center">
          By continuing, you agree to the <br />
          <a href="/legal.html#terms-of-use" className="primary-text">Terms of Use</a> &{' '}
          <a href="/legal.html#privacy-policy" className="primary-text">Privacy Policy</a>
        </p>
      </div>
    </section>
  );
}

export default ForgotPassword;